import React from 'react'
import PropTypes from 'prop-types'
import upperCase from 'lodash/upperCase'
import {useTranslation} from 'react-i18next'
import findIndex from 'lodash/findIndex'
import {AuditPaneContext} from '../../../context/AuditPane'
import {auditFilterFormatter} from '../../../utils/auditDatePeriodFormatter'

function GroupTabPanels({data}) {
  const {t} = useTranslation()
  const paneState = React.useContext(AuditPaneContext)

  const processFilters = data => {
    const uniqueFilters = data?.audit_entity_filters_attributes.reduce((agg, ele) => {
      const test = findIndex(agg, e => e?.name === ele.field_name)
      if (test < 0) {
        return [...agg, {name: ele.field_name, count: 1}]
      } else {
        agg[test].count++
        return agg
      }
    }, [])
    return {...data, _filters: uniqueFilters}
  }

  data = processFilters(data)

  const previewTabPanel = data => {
    return (
      <>
        {data?.audit_entity_filters_attributes?.length > 0 && (
          <div className="audit-expand__column">
            <p className="audit__label mb_0">{upperCase(`${t('audit.expand.labels.filters')}`)}</p>
            <div className="audit-detail-tab__scroll col-12 pl_0">
              {data?.audit_entity_filters_attributes.map(filter => {
                return (
                  <span class="badge ap-pillbox  ap-pillbox--dark-blue" key={filter.value_name}>
                    {' '}
                    {filter.value_name}
                  </span>
                )
              })}
            </div>
          </div>
        )}
        {data?.audit_entity_auto_update_fields_attributes?.length > 0 && (
          <div className="audit-expand__column pt-2">
            <p className="audit__label mb_0">
              {upperCase(`${t('audit.expand.labels.update_fields')}`)}
            </p>
            <div className="audit-detail-tab__scroll col-12 pl_0">
              {data?.audit_entity_auto_update_fields_attributes.map(field => (
                <span class="badge ap-pillbox  ap-pillbox--dark-blue" key={field.value_name}>
                  {`${auditFilterFormatter(field)}`}
                </span>
              ))}
            </div>
          </div>
        )}
        {data?.audit_entity_user_fields_attributes?.length > 0 && (
          <div className="audit-expand__column pt-2">
            <p className="audit__label mb_0">
              {upperCase(`${t('audit.expand.labels.user_update_fields')}`)}
            </p>
            <div className="audit-detail-tab__scroll col-12 pl_0">
              {data?.audit_entity_user_fields_attributes.map(field => (
                <span class="badge ap-pillbox  ap-pillbox--dark-blue" key={field.field_name}>
                  {field.field_name}
                </span>
              ))}
            </div>
          </div>
        )}
      </>
    )
  }

  const expandTabPanel = data => {
    return (
      <>
        <div className="audit-expand__column width_100">
          <p className="audit__label mb_4">{upperCase(`${t('audit.expand.labels.filters')}`)}</p>
          <div className="audit-detail-tab__scroll">
            {data?._filters?.length > 0 &&
              data?._filters.map(filter => (
                <span className="audit__value audit__value--13 mb_2">{`${filter.name}(${filter.count})`}</span>
              ))}
          </div>
        </div>
        <div className="audit-expand__column width_100 ml_6">
          <p className="audit__label mb_4">
            {upperCase(`${t('audit.expand.labels.update_fields')}`)}
          </p>
          <div className="audit-expand-tab__scroll">
            {data?.audit_entity_auto_update_fields_attributes?.length > 0 &&
              data?.audit_entity_auto_update_fields_attributes.map(field => (
                <span className="audit__value audit__value--13 mb_2">
                  {' '}
                  {`${auditFilterFormatter(field)}`}
                </span>
              ))}
          </div>
        </div>
        <div className="audit-expand__column width_100 ml_6">
          <p className="audit__label mb_4">
            {upperCase(`${t('audit.expand.labels.user_update_fields')}`)}
          </p>
          <div className="audit-expand-tab__scroll">
            {data?.audit_entity_user_fields_attributes?.length > 0 &&
              data?.audit_entity_user_fields_attributes.map(field => (
                <span className="audit__value audit__value--13 mb_2">{field.field_name}</span>
              ))}
          </div>
        </div>
      </>
    )
  }

  return <>{paneState.isExpandOpen ? expandTabPanel(data) : previewTabPanel(data)}</>
}

GroupTabPanels.propTypes = {
  data: PropTypes.shape({}).isRequired,
}

GroupTabPanels.displayName = 'GroupTabPanels'

export default GroupTabPanels
